import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formatNumber } from '../../../service/market';

import css from '../../../styles/instrument/orders/orders';

class OrderRow extends Component {
    static propTypes = {
        ASK: PropTypes.number,
        ASKVOL: PropTypes.number,
        BID: PropTypes.number,
        BIDVOL: PropTypes.number,
        max: PropTypes.number,
    }

    renderBar() {
        const { ASKVOL, BIDVOL, max } = this.props;

        const askWidth = ASKVOL / max * 100;
        const bidWidth = BIDVOL / max * 100;

        return (
            <td className={css.barCell}>
                <div className={css.container}>
                    <div className={css.bar}>
                        <div className={css.askFill} style={{ width: `${askWidth}%` }} />
                    </div>
                    <div className={css.bar}>
                        <div className={css.bidFill} style={{ width: `${bidWidth}%` }} />
                    </div>
                </div>
            </td>
        );
    }

    render() {
        return (
            <tr className={css.tableRow}>
                <td>{formatNumber(this.props.ASKVOL, 0)}</td>
                <td>{formatNumber(this.props.ASK)}</td>
                {this.renderBar()}
                <td className={css.alignRight}>{formatNumber(this.props.BID)}</td>
                <td className={css.alignRight}>{formatNumber(this.props.BIDVOL, 0)}</td>
            </tr>
        );
    }
}

export default OrderRow;



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/orders/OrderRow.js
 **/